export default {"src":"/_next/static/media/close-icon-black.87a5a011.svg","height":10,"width":10};